import type { UnidadeOperacionalFilters } from '../../unidades/types/unidade'
import type {
  PeriodoFilters,
  ResumoFilters,
  SituacaoUnidadesFilters,
} from '../../dashboard/types/dashboard'
import type { RelatorioFilters, SugestaoFilters, VisitaListFilters } from '../types/visita'

/**
 * Chaves de cache de todo o Operacional sob uma raiz só: uma mudança de status
 * de visita (aprovar, finalizar, remarcar…) afeta listas, calendário e painel,
 * e `invalidateQueries({ queryKey: operacionalKeys.all })` cobre tudo.
 */
export const operacionalKeys = {
  all: ['operacional'] as const,

  roteiros: {
    all: () => [...operacionalKeys.all, 'roteiros'] as const,
    list: (ativo?: boolean) =>
      [...operacionalKeys.roteiros.all(), 'list', ativo ?? 'todos'] as const,
    detail: (id: string) => [...operacionalKeys.roteiros.all(), 'detail', id] as const,
  },

  unidades: {
    all: () => [...operacionalKeys.all, 'unidades'] as const,
    list: (filters: UnidadeOperacionalFilters) =>
      [...operacionalKeys.unidades.all(), 'list', filters] as const,
    roteiros: (unidadeId: string) =>
      [...operacionalKeys.unidades.all(), 'roteiros', unidadeId] as const,
  },

  equipes: {
    all: () => [...operacionalKeys.all, 'equipes'] as const,
    list: (regiaoId?: string) =>
      [...operacionalKeys.equipes.all(), 'list', regiaoId ?? ''] as const,
  },

  visitas: {
    all: () => [...operacionalKeys.all, 'visitas'] as const,
    list: (filters: VisitaListFilters) =>
      [...operacionalKeys.visitas.all(), 'list', filters] as const,
    periodo: (filters: Omit<VisitaListFilters, 'page' | 'pageSize'>) =>
      [...operacionalKeys.visitas.all(), 'periodo', filters] as const,
    sugestoes: (filters: SugestaoFilters) =>
      [...operacionalKeys.visitas.all(), 'sugestoes', filters] as const,
    relatorios: (filters: RelatorioFilters) =>
      [...operacionalKeys.visitas.all(), 'relatorios', filters] as const,
    detail: (id: string) => [...operacionalKeys.visitas.all(), 'detail', id] as const,
    historico: (id: string) => [...operacionalKeys.visitas.all(), 'historico', id] as const,
  },

  minhas: {
    all: () => [...operacionalKeys.all, 'minhas'] as const,
    list: (filters: object) => [...operacionalKeys.minhas.all(), 'list', filters] as const,
    detail: (id: string) => [...operacionalKeys.minhas.all(), 'detail', id] as const,
  },

  revisao: {
    all: () => [...operacionalKeys.all, 'revisao'] as const,
    list: (filters: object) => [...operacionalKeys.revisao.all(), 'list', filters] as const,
  },

  dashboard: {
    all: () => [...operacionalKeys.all, 'dashboard'] as const,
    resumo: (filters: ResumoFilters) =>
      [...operacionalKeys.dashboard.all(), 'resumo', filters] as const,
    porRegiao: (filters: PeriodoFilters) =>
      [...operacionalKeys.dashboard.all(), 'por-regiao', filters] as const,
    equipesHoje: (regiaoId?: string) =>
      [...operacionalKeys.dashboard.all(), 'equipes-hoje', regiaoId ?? ''] as const,
    unidades: (filters: SituacaoUnidadesFilters) =>
      [...operacionalKeys.dashboard.all(), 'unidades', filters] as const,
  },
}
